<template>
  <div class="service-editor">
    <div class="row">
      <div class="col icon-container">
        <label class="label">ไอคอน</label>
        <img :src="thumbnailUrl" class="thumbnail" />
        <sc-button
          v-if="!disabled"
          class="thumbnail-button"
          @click="handleClickChooseIconButton"
          >เลือกไอคอน</sc-button
        >
      </div>
      <div class="col">
        <label class="label">ชื่อ</label>
        <el-input
          v-model="nameModel"
          :disabled="disabled"
          class="input"
        ></el-input>
        <label class="label">รายละเอียด (อย่างย่อ)</label>
        <el-input
          v-model="shortDescriptionModel"
          :disabled="disabled"
          class="input"
        ></el-input>
        <el-checkbox v-model="hasExternalLink" class="input"
          >มี external-link</el-checkbox
        >
        <div v-if="hasExternalLink" class="externalLink">
          <label class="label">หัวข้อ</label>
          <el-input
            v-model="externalLinkTitle"
            :disabled="disabled"
            class="input"
            >ชื่อหัวข้อ</el-input
          >
          <label class="label">ประเภท</label>
          <el-select
            v-model="externalLinkType"
            class="input"
            placeholder="Select"
          >
            <el-option
              v-for="item in externalLinkTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label class="label">URL</label>
          <el-input
            v-model="externalLinkUrl"
            :disabled="disabled"
            class="input"
            >URL</el-input
          >
        </div>
        <div class="row">
          <div class="col-5">
            <label class="label">ผู้ให้บริการ</label>
            <provider-selector
              v-model="providerModel"
              :disabled="isCanNotEditService || disabled"
              :is-show-provider-vat="true"
              class="input"
            ></provider-selector>
          </div>
          <div class="col-7">
            <label class="label">ประเภทของสินค้าและบริการ (SAP)</label>
            <el-select
              v-model="sapServiceTypeModel"
              :disabled="isCanNotEditService"
              style="width: 100%"
            >
            <el-option
              v-for="t in sapServiceTypeDropdown"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
            </el-select>
          </div>
        </div>
        <div class="input">
          <input
            v-model="serviceCategory"
            type="radio"
            name="type"
            :value="serviceTypes.PRODUCT"
            :disabled="isCanNotEditService"
          />
          &nbsp; สินค้า &nbsp;&nbsp;
          <input
            v-model="serviceCategory"
            type="radio"
            name="type"
            :value="serviceTypes.SERVICE"
            :disabled="isCanNotEditService"
          />
          &nbsp; บริการ &nbsp;&nbsp;
          <input
            v-model="serviceCategory"
            type="radio"
            name="type"
            :value="serviceTypes.DOTLIFE_PRODUCT"
            :disabled="isCanNotEditService"
          />
          &nbsp; สินค้า DotLife
        </div>
        <div v-if="hasQuota && !isServiceProductType" class="input">
          <label class="label">ประเภทของบริการ</label>
          <input
            v-model="serviceTypeModel"
            type="radio"
            name="serviceType"
            :value="serviceTypes.SERVICE"
            :disabled="isCanNotEditService"
          />
          &nbsp; บริการ &nbsp;&nbsp;
          <input
            v-model="serviceTypeModel"
            type="radio"
            name="serviceType"
            :value="serviceTypes.PRODUCT"
            :disabled="isCanNotEditService"
          />
          &nbsp; สินค้าที่ให้ลูกค้านัดบริการ
        </div>
        <div
          v-if="isShowMaterialCode && hasQuota && !isServiceProductType"
          class="input"
        >
          <label class="label">รับรู้รายได้บน SAP</label>
            <el-select
              v-model="sapServiceRecognizeRevenueModel"
              class="revenue-dropdown"
              :disabled="isCanNotEditService"
            >
            <el-option
              v-for="t in sapServiceRecognizeRevenueDropdown"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
            </el-select>
        </div>
        <el-checkbox
          v-model="hasOptions"
          :disabled="isCanNotEditService"
          >มี options</el-checkbox
        >
        <p v-if="!isServiceProductType" class="service-vat">{{ vatRegisteredByService }}</p>
        <template v-if="!isServiceProductType && (!isSelectOnetimeType || hasQuota)">
          <div>
            <label class="label">จำนวนครั้งที่จัดส่ง (สินค้า/บริการ)</label>
            <el-input
              :disabled="disabled"
              :value="quota"
              :min="0"
              :readonly="isReadOnly"
              class="input quota"
              type="number"
              @input="handleChangeInput('quota', $event)"
            ></el-input>
          </div>
          <!-- TODO: show service appointment date constraint when ready on production -->
          <!-- <service-appointment-date-constraint-editor
            v-model="value.appointDateConstraints"
            v-show="hasQuota"
          >
          </service-appointment-date-constraint-editor> -->
          <service-appointment-duration
            v-if="!hasOptions && !isServiceProductType"
            :value="value"
            @input="handleAppointmentDurationInput"
            @removeDuration="handleRemoveDuration"
            @addDuration="handleAddDuration"
          ></service-appointment-duration>
        </template>
        <div v-if="!hasOptions && !isServiceProductType">
          <label class="label">ต้นทุนรวม</label>
          <el-input
            class="input cost"
            :disabled="isTotalCostDisabled"
            :value="costInputValue"
            type="text"
            inputmode="decimal"
            @input="handleChangeInput('cost', $event)"
          ></el-input>
        </div>
        <div v-if="!hasOptions && (isShowMaterialCode || isServiceProductType)">
          <div class="row">
            <div class="col-6">
              <label class="label">Material Code</label>
              <material-selector
                v-model="materialCodeModel"
                @unitName="handleUnitName"
              ></material-selector>
            </div>
            <div class="col-3">
              <label class="label">จำนวน{{ value.unitName }}</label>
              <material-quantity-selector
                v-model="materialQuantityModel"
              ></material-quantity-selector>
            </div>
          </div>
        </div>
        <div v-if="isServiceProductType && !hasOptions">
          <service-product-selector
            v-model="serviceProduct"
            :disabled="disabled"
          ></service-product-selector>
        </div>
        <div
          v-if="isServiceProductType && !hasOptions && serviceProductCost !== null"
          class="service-product-cost-section"
        >
          <p class="service-vat">{{ vatRegisteredByService }}</p>
          <div class="service-product-cost-label">
            <label class="label service-product-cost-title">ต้นทุนรวม</label>
            <service-promotion-badge
              v-if="hasServiceProductPromotion"
            ></service-promotion-badge>
          </div>
          <el-input
            class="input cost service-product-cost-input"
            :value="serviceProductCostDisplay"
            disabled
            type="text"
          ></el-input>
          <service-promotion-meta
            v-if="hasServiceProductPromotion"
            class="service-product-promotion-meta"
            :original-cost="serviceProductOriginalCost"
            :promotion-period="serviceProductPromotionPeriod"
          ></service-promotion-meta>
        </div>
        <div v-if="hasQuota && !isServiceProductType">
          <label class="label">จำนวนวันนัดล่วงหน้า</label>
          <el-input
            :disabled="isCanNotEditService"
            :value="minimumAdvanceDuration"
            class="input minimumAdvanceDuration"
            min="1"
            type="number"
            @input="handleChangeInput('minimumAdvanceDuration', $event)"
          ></el-input>
        </div>

        <!-- TODO: remove ENV check when ready to production -->
        <!-- eslint-disable-next-line vue/no-lone-template -->
        <template v-if="hasOptions">
          <div>
            <service-option-editor
              v-model="serviceOptions"
              @setEmptyServiceOptionCosts="handleEmptyOptionCost"
              @isCheckCombineOption="handleCheckCombineOption"
            ></service-option-editor>
          </div>
          <div>
            <div v-if="hasOptionSwitch">
              <sc-button
                variant="primary"
                @click="handleClickGenerateCombineOption"
                >สรุป ราคาทุน</sc-button
              >
            </div>
            <div v-else>
              <sc-button variant="primary" @click="handleClickEditOption"
                >แก้ไข option</sc-button
              >
            </div>
          </div>
          <div>
            <!-- eslint-disable-next-line vue/no-lone-template -->
            <template v-if="hasAppointCosts">
              <service-list-option
                v-model="serviceOptionCosts"
              ></service-list-option>
            </template>
          </div>
        </template>
        <label class="label">รายละเอียด</label>
        <el-input
          v-model="descriptionModel"
          :disabled="disabled"
          class="input"
          type="textarea"
          rows="7"
        ></el-input>
        <label class="label">เงื่อนไขการใช้บริการ</label>
        <el-input
          v-model="termsAndConditionsModel"
          :disabled="disabled"
          class="input"
          type="textarea"
          rows="7"
        ></el-input>
        <label v-if="packagesByServiceList" class="label"
          >แพ็คเกจที่ร่วมบริการ</label
        >
        <div>
          <package-list-item
            v-for="item in packagesByServiceList"
            :key="item.key"
            v-bind="item"
          >
          </package-list-item>
        </div>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseIconDialog"
      @cancel="handleCancelChooseIconDialog"
      @confirm="handleConfirmChooseIconDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import { Input, Select, Option, Checkbox } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import ProviderSelector from "@/lib/components/ProviderSelector";
import { isNil } from "ramda";
import { uuid } from "vue-uuid";
import materialSelector from "@/lib/components/materialSelector";
import materialQuantitySelector from "@/lib/components/materialQuantitySelector";
import cloneDeep from "lodash/cloneDeep";
import { serviceType } from "@/lib/mapper";
import {
  formatServicePriceDisplay,
  formatServicePriceInputValue,
  sanitizeServicePriceInput,
  sumServicePriceInputValues,
} from "../utils/servicePrice";
import ServiceProductSelector from "./ServiceProductSelector";
import ServicePromotionBadge from "./ServicePromotionBadge";
import ServicePromotionMeta from "./ServicePromotionMeta";
import {
  getEmptyServiceProductFields,
  getServiceProductCostSummary,
  getServiceProductFieldsForOptionToggle,
  getServiceProductSelectorValue,
  getServiceTypeChangeResetFields,
  getServiceOptionSummaryValidationMessage,
  getUpdatedPrimaryServiceProducts,
  shouldDisableTotalCostInput,
  setupServiceProductOptionCosts,
} from "../utils/serviceForm";
import ServiceOptionEditor from "./ServiceOptionEditor";
import ServiceAppointmentDuration from "./ServiceAppointmentDuration";
import PackageListItem from "../../packages/components/PackageListItem";
import ServiceListOption from "./ServiceListOption";

export default {
  components: {
    ScButton,
    ImagePickerModal,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
    ProviderSelector,
    ServiceOptionEditor,
    ServiceAppointmentDuration,
    PackageListItem,
    ServiceListOption,
    "material-selector": materialSelector,
    "material-quantity-selector": materialQuantitySelector,
    ServiceProductSelector,
    ServicePromotionBadge,
    ServicePromotionMeta,
  },
  props: {
    value: { type: Object, default: () => ({}) },
    iconUrl: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    providers: { type: Array, default: () => [] },
  },
  data() {
    const sapServiceTypeDropdown = [
      { value: "PREPAID", label: "Prepaid" },
      { value: "CUSTOMIZED", label: "Customized" },
      { value: "NORMAL", label: "Normal" },
    ]

    const sapServiceRecognizeRevenueDropdown = [
      { value: "APPOINTMENT_REVENUE", label: "รับรู้รายได้ทุกครั้งที่นัด" },
      { value: "ONETIME_REVENUE", label: "รับรู้รายได้ครั้งเดียว" },
    ]

    const permission = JSON.parse(localStorage.getItem("adminRolePermission")) || null;

    return {
      isShowModal: false,
      externalLinkTypeOptions: [
        {
          value: "PDF",
          label: "PDF"
        }
      ],
      hasExternalLink: false,
      isEditTotalCost: false,
      isSelectOptionType: false,
      isSelectOnetimeType: true,
      sapServiceTypeDropdown,
      unitNameSelect: null,
      sapServiceRecognizeRevenueDropdown,
      permission
    };
  },
  computed: {
    nameModel: {
      get() {
        return this.value.name;
      },
      set(name) {
        this.$emit("input", { ...this.value, name });
      },
    },
    shortDescriptionModel: {
      get() {
        return this.value.shortDescription;
      },
      set(shortDescription) {
        this.$emit("input", { ...this.value, shortDescription });
      },
    },
    quota() {
      return this.value.quota;
    },
    cost() {
      return this.value.cost;
    },
    costInputValue() {
      return formatServicePriceInputValue(this.cost, this.isTotalCostDisabled);
    },
    minimumAdvanceDuration() {
      return this.value.minimumAdvanceDuration;
    },
    externalLinkTitle: {
      get() {
        return this.value.externalLink && this.value.externalLink.title;
      },
      set(title) {
        this.updateExternalLink({ title });
      },
    },
    externalLinkType: {
      get() {
        return this.value.externalLink && this.value.externalLink.type;
      },
      set(type) {
        this.updateExternalLink({ type });
      },
    },
    externalLinkUrl: {
      get() {
        return this.value.externalLink && this.value.externalLink.url;
      },
      set(url) {
        this.updateExternalLink({ url });
      },
    },
    providerModel: {
      get() {
        return this.value.provider;
      },
      set(provider) {
        this.$emit("input", { ...this.value, provider });
      },
    },
    sapServiceTypeModel: {
      get() {
        return this.value.sapServiceType;
      },
      set(sapServiceType) {
        this.$emit("input", { ...this.value, sapServiceType });
      },
    },
    serviceTypeModel: {
      get() {
        return this.value.serviceType;
      },
      set(serviceTypeValue) {
        this.$emit("input", { ...this.value, serviceType: serviceTypeValue });
      },
    },
    sapServiceRecognizeRevenueModel: {
      get() {
        return this.value.sapServiceRecognizeRevenue;
      },
      set(sapServiceRecognizeRevenue) {
        this.$emit("input", { ...this.value, sapServiceRecognizeRevenue });
      },
    },
    materialCodeModel: {
      get() {
        return this.value.materialCode;
      },
      set(materialCode) {
        this.$emit("input", { ...this.value, materialCode });
      },
    },
    materialQuantityModel: {
      get() {
        return this.value.materialQuantity;
      },
      set(materialQuantity) {
        this.$emit("input", { ...this.value, materialQuantity });
      },
    },
    descriptionModel: {
      get() {
        return this.value.description;
      },
      set(description) {
        this.$emit("input", { ...this.value, description });
      },
    },
    termsAndConditionsModel: {
      get() {
        return this.value.termsAndConditions;
      },
      set(termsAndConditions) {
        this.$emit("input", { ...this.value, termsAndConditions });
      },
    },
    externalLink() {
      return this.value.externalLink || {};
    },
    isCanNotEditService() {
      return this.value.isCanNotEditService;
    },
    isTotalCostDisabled() {
      return shouldDisableTotalCostInput({
        disabled: this.disabled,
        hasQuota: this.hasQuota,
      });
    },
    serviceOptions: {
      get() {
        return this.value;
      },
      set(serviceOptions) {
        this.$emit("input", { ...this.value, serviceOptions });
      },
    },
    hasAppointCosts() {
      return this.hasAppointmentCosts();
    },
    serviceOptionCosts: {
      get() {
        return this.value;
      },
      set(serviceOptionCosts) {
        this.$emit("input", { ...this.value, serviceOptionCosts });
      },
    },
    serviceModel: {
      get() {
        return cloneDeep(this.value);
      },
      set(serviceModel) {
        this.$emit("input", cloneDeep(serviceModel));
      },
    },
    thumbnailUrl() {
      if (!this.chooseIconDialog.thumbnailUrl) {
        return "https://placehold.co/300";
      }

      return this.chooseIconDialog.thumbnailUrl;
    },
    chooseIconDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: !this.disabled,
        title: "เลือกรูปไอคอนบริการ",
        width: 200,
        height: 200,
        recommendWidth: 200,
        recommendHeight: 200,
        thumbnailFile: this.value.iconFile,
        thumbnailUrl: this.iconUrl
      };
    },
    serviceTypes() {
      return serviceType;
    },
    serviceCategory: {
      get() {
        return this.value.serviceType || serviceType.PRODUCT;
      },
      set(category) {
        this.handleSelectCategory(category);
      }
    },
    isServiceProductType() {
      return this.value.serviceType === serviceType.DOTLIFE_PRODUCT;
    },
    serviceProduct: {
      get() {
        return getServiceProductSelectorValue({ formValue: this.value });
      },
      set(product) {
        const costSummary = getServiceProductCostSummary(product);

        this.$emit("input", {
          ...this.value,
          serviceProductId: product ? product.id : null,
          serviceProductName: product ? product.name : "",
          serviceProductCode: product ? product.code : "",
          serviceProductQuantity: product ? product.stock : null,
          serviceProductCost: product ? costSummary.cost : null,
          serviceProducts: getUpdatedPrimaryServiceProducts(
            this.value.serviceProducts,
            product
          ),
          cost: product ? costSummary.cost : null,
        });
      }
    },
    serviceProductCostSummary() {
      return getServiceProductCostSummary(this.serviceProduct);
    },
    serviceProductCost() {
      return isNil(this.serviceProductCostSummary.cost)
        ? null
        : this.serviceProductCostSummary.cost;
    },
    serviceProductCostDisplay() {
      return this.formatPriceDisplay(this.serviceProductCost);
    },
    hasServiceProductPromotion() {
      return this.serviceProductCostSummary.hasPromotion;
    },
    serviceProductOriginalCost() {
      return isNil(this.serviceProductCostSummary.originalCost)
        ? null
        : this.serviceProductCostSummary.originalCost;
    },
    serviceProductPromotionPeriod() {
      return this.serviceProductCostSummary.promotionPeriod;
    },
    hasOptions: {
      get() {
        return !isNil(this.value.serviceOptions);
      },
      set(hasOptions) {
        const serviceProductFields = getServiceProductFieldsForOptionToggle(
          this.isServiceProductType,
          this.value.appointDurationSlots
        );
        const serviceOptions = hasOptions
          ? [
              {
                id: uuid.v4(),
                title: "",
                extra_option: false,
                is_show_delete_option: "hasOption",
                variants: [
                  {
                    variant_id: uuid.v4(),
                    title: "",
                    is_out_of_stock: false,
                    is_not_sale: false,
                    is_show_delete_option: "hasOption",
                    material_code: null,
                    material_quantity: null,
                    serviceProduct: null
                  },
                  {
                    variant_id: uuid.v4(),
                    title: "",
                    is_out_of_stock: false,
                    is_not_sale: false,
                    is_show_delete_option: "hasOption",
                    material_code: null,
                    material_quantity: null,
                    serviceProduct: null
                  }
                ]
              }
            ]
          : null;

        this.$emit("input", {
          ...this.value,
          ...serviceProductFields,
          serviceOptions,
          serviceOptionCosts: null,
          hasOptionSwitch: true,
          materialCode: hasOptions ? null : this.value.materialCode,
          materialQuantity: hasOptions ? null : this.value.materialQuantity,
          unitName: hasOptions ? null : this.value.unitName,
          appoint_duration_slots: null
        });
      },
    },
    hasQuota() {
      return this.quota > 0;
    },
    isReadOnly() {
      return this.value.appointCostReadOnly;
    },
    packagesByServiceList() {
      return this.value.packagesByServiceList;
    },
    isTotalCost() {
      return this.isEditTotalCost;
    },
    isOnetimeType() {
      return this.isSelectOnetimeType;
    },
    isOptionType() {
      return this.isSelectOptionType;
    },
    hasOptionSwitch() {
      return this.value.hasOptionSwitch;
    },
    isShowMaterialCode() {
      return this.value.sapServiceType === 'NORMAL';
    },
    vatRegisteredByService() {
      if (typeof this.value.isVatRegistered === "boolean") {
        return this.value.isVatRegistered
          ? "บริการนี้ต้นทุนรวม Vat"
          : "บริการนี้ต้นทุนไม่รวม Vat";
      }

      if (!this.value.provider) {
        return "";
      }

      return this.value.provider.isVatRegistered
        ? "บริการนี้ต้นทุนรวม Vat"
        : "บริการนี้ต้นทุนไม่รวม Vat";
    }
  },
  watch: {
    hasExternalLink() {
      this.handleHasExternalLinkChange();
    },
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.hasExternalLink = !!this.value.externalLink;
    },
    handleChangeInput(key, value) {
      const isNumber = ["quota", "cost", "minimumAdvanceDuration"].includes(key);
      const inputValue = key === "cost"
        ? sanitizeServicePriceInput(value)
        : value;
      let nextValue = {
        ...this.value,
        [key]: isNumber && key !== "cost" ? +inputValue : inputValue,
      };

      if (key === "quota") {
        this.isEditTotalCost = inputValue > 0;
        nextValue = {
          ...nextValue,
          serviceType: this.isEditTotalCost
            ? serviceType.SERVICE
            : serviceType.PRODUCT
        };

        if (nextValue.serviceOptions) {
          nextValue = this.createCombineOptionDetail(nextValue, false);
        }
      }

      this.$emit("input", nextValue);
    },
    handleClickChooseIconButton() {
      this.showChooseIconDialog();
    },
    handleCancelChooseIconDialog() {
      this.hideChooseIconDialog();
    },
    handleConfirmChooseIconDialog(file) {
      this.$emit("input", { ...this.value, iconFile: file });
      this.hideChooseIconDialog();
    },
    updateExternalLink(patch) {
      this.$emit("input", {
        ...this.value,
        externalLink: {
          title: "",
          type: "PDF",
          url: "",
          ...this.value.externalLink,
          ...patch,
        },
      });
    },
    showChooseIconDialog() {
      this.isShowModal = true;
    },
    hideChooseIconDialog() {
      this.isShowModal = false;
    },
    handleHasExternalLinkChange() {
      if (!this.hasExternalLink) {
        this.emitExternalLink(null);
        return;
      }

      if (
        this.value.externalLink &&
        this.value.externalLink.title &&
        this.value.externalLink.url
      ) {
        return;
      }

      this.emitExternalLink({ title: "", type: "PDF", url: "" });
    },
    handleExternalLinkInput(key, value) {
      const externalLink = {
        title: "",
        type: "PDF",
        url: "",
        ...this.value.externalLink,
        [key]: value,
      };

      this.emitExternalLink(externalLink);
    },
    emitExternalLink(externalLink) {
      this.$emit("input", { ...this.value, externalLink });
    },
    handleRemoveDuration(dataForRemove) {
      this.$emit("removeDuration", dataForRemove);
    },
    handleAddDuration(slotNumber) {
      this.$emit("addDuration", slotNumber);
    },
    handleAppointmentDurationInput(updatedValue) {
      const totalCost = sumServicePriceInputValues(
        updatedValue.appointDurationSlots.map((slot) => slot.appointCost)
      );

      this.$emit("input", {
        ...updatedValue,
        cost: totalCost,
      });
    },
    handleSelectCategory(category) {
      const serviceTypeChangeResetFields = getServiceTypeChangeResetFields({
        currentServiceType: this.value.serviceType,
        nextServiceType: category,
        serviceOptions: this.value.serviceOptions,
      });

      if (category === serviceType.DOTLIFE_PRODUCT) {
        this.$emit("input", {
          ...this.value,
          ...serviceTypeChangeResetFields,
          hasServiceProduct: true,
          quota: 0,
          serviceType: serviceType.DOTLIFE_PRODUCT,
        });
        this.isSelectOnetimeType = true;
      } else if (category === serviceType.SERVICE) {
        this.$emit("input", {
          ...this.value,
          ...serviceTypeChangeResetFields,
          ...getEmptyServiceProductFields(),
          hasServiceProduct: false,
          quota: 1,
          serviceType: serviceType.SERVICE,
        });
        this.isSelectOnetimeType = false;
      } else {
        this.$emit("input", {
          ...this.value,
          ...serviceTypeChangeResetFields,
          ...getEmptyServiceProductFields(),
          hasServiceProduct: false,
          quota: 0,
          serviceType: serviceType.PRODUCT,
        });
        this.isSelectOnetimeType = true;
      }
    },
    hasAppointmentCosts() {
      const hasAppointmentCosts = !!this.value.serviceOptionCosts;

      return hasAppointmentCosts;
    },
    async handleClickGenerateCombineOption() {
      this.$emit("isCheckCombineOption", false);

      const validationMessage = getServiceOptionSummaryValidationMessage(
        this.value.serviceOptions,
        { isServiceProductType: this.isServiceProductType }
      );

      if (validationMessage) {
        this.$message.error(validationMessage);
        return;
      }

      await this.createCombineOptionDetail();
    },
    createCombineOptionDetail(value = this.value, shouldEmit = true) {
      const {quota} = value;
      const {serviceOptions} = value;
      let serviceOptionCosts;

      if (value.serviceType === serviceType.DOTLIFE_PRODUCT) {
        serviceOptionCosts = setupServiceProductOptionCosts({
          serviceOptions,
          quota,
          currentServiceOptionCosts: value.serviceOptionCosts,
          createId: () => uuid.v4(),
        });

        const nextValue = {
          ...value,
          serviceOptionCosts,
          hasOptionSwitch: false,
        };

        return shouldEmit
          ? this.$emit("input", nextValue)
          : nextValue;
      }

      const serviceMainOption = serviceOptions
        ? serviceOptions.find((option) => option.extra_option === false)
        : null;

      const serviceExtraOption = serviceOptions
        ? serviceOptions.find((option) => option.extra_option === true)
        : null;

      if (serviceMainOption && serviceMainOption.variants) {
        serviceOptionCosts = serviceMainOption.variants.map(
          (variant, variantIndex) => {
            const optionId = this.getOldOptionIdOrGenerate(variantIndex);
            let appointmentAmount = null;
            let isProduct = null;

            if (quota > 0) {
              appointmentAmount = new Array(quota).fill(0);
              isProduct = false;
            } else {
              appointmentAmount = new Array(1).fill(0);
              isProduct = true;
            }

            const appointments = appointmentAmount.map((_, index) => ({ no: index + 1, cost: null }));

            this.option = [
              {
                title: variant.title,
                is_not_sale: variant.is_not_sale,
                is_out_of_stock: variant.is_out_of_stock,
                material_code: variant.material_code,
                appointments,
                material_quantity: variant.material_quantity
              },
            ];

            if (serviceExtraOption) {
              serviceExtraOption.variants.forEach((extraVariant) => {
                this.option.push({
                  title: extraVariant.title,
                  is_not_sale: extraVariant.is_not_sale,
                  is_out_of_stock: extraVariant.is_out_of_stock,
                  material_code: extraVariant.material_code,
                  appointments,
                  material_quantity: extraVariant.material_quantity,
                });
              });
            }

            const combinationCosts = this.option.map((appointmentCost, appointmentCostIndex) => {
              const id = this.getOldCombineOptionIdOrGenerate(variantIndex, appointmentCostIndex);

              const appointmentCosts = appointmentCost.appointments.map((appoint) => {
                  const appointNo = appoint.no;
                  const cost = this.getOldCombineAppointmentValue(
                    variantIndex,
                    appointmentCostIndex,
                    appointNo,
                    "cost"
                  );

                  return {
                    appoint_no: appointNo,
                    cost
                  };
              });

              return {
                id,
                is_not_sale: appointmentCost.is_not_sale,
                is_out_of_stock: appointmentCost.is_out_of_stock,
                material_code: appointmentCost.material_code,
                title: appointmentCost.title,
                appointment_costs: appointmentCosts,
                material_quantity: appointmentCost.material_quantity
              };
            });

          return {
            id: optionId,
            title: variant.title,
            is_product: isProduct,
            combination_costs: combinationCosts
          };
        });
      }
      const nextValue = {
        ...value,
        serviceOptionCosts,
        hasOptionSwitch: false,
      };

      return shouldEmit
        ? this.$emit("input", nextValue)
        : nextValue;
    },
    handleClickEditOption() {
      this.$emit("input", { ...this.value, hasOptionSwitch: true });
    },
    getOldCombineOptionIdOrGenerate(variantIndex, combineOptionIndex) {
      let combineOptionId = uuid.v4();

      if (this.value.serviceOptionCosts) {
        this.value.serviceOptionCosts.forEach((serviceOptionCost, serviceOptionCostIndex) => {
          if (serviceOptionCostIndex === variantIndex) {
            serviceOptionCost.combination_costs.forEach((combinationCost, combinationCostIndex) => {
              if (combinationCostIndex === combineOptionIndex) {
                combineOptionId = combinationCost.id;
              }
            });
          }
        });
      }

      return combineOptionId;
    },
    getOldCombineAppointmentValue(
      variantIndex,
      combineOptionIndex,
      appointNo,
      valueOutput
    ) {
      let appointmentOutput = null;

      if (this.value.serviceOptionCosts) {
        const option = this.value.serviceOptionCosts.find(
          (_, serviceOptionCostIndex) => variantIndex === serviceOptionCostIndex
        );

        const combineOption = option
          ? option.combination_costs.find(
            (_, combinationCostIndex) => combinationCostIndex === combineOptionIndex)
          : null;

        const combineAppointment = combineOption
          ? combineOption.appointment_costs.find((combinationCost) => (
              combinationCost.appoint_no === appointNo)
            )
          : null;

        if (combineAppointment) {
          if (typeof combineAppointment[valueOutput] === "number") {
            appointmentOutput = parseFloat(combineAppointment[valueOutput])
          } else {
            appointmentOutput = combineAppointment[valueOutput]
          }
        }
      }

      return appointmentOutput
    },
    getOldOptionIdOrGenerate(variantIndex) {
      let optionId = uuid.v4();

      if (this.value.serviceOptionCosts) {
        this.value.serviceOptionCosts.forEach(
          (serviceOptionCost, serviceOptionCostIndex) => {
            if (serviceOptionCostIndex === variantIndex) {
              optionId = serviceOptionCost.id;
            }
          });
      }

      return optionId;
    },
    handleEmptyOptionCost() {
      this.$emit("setEmptyServiceOptionCosts");
    },
    handleCheckCombineOption(value) {
      this.$emit("isCheckCombineOption", value);
    },
    formatPriceDisplay(cost) {
      return formatServicePriceDisplay(cost);
    },

    handleUnitName(value) {
      if (value) {
        this.$emit("input",  {
          ...this.value,
          unitName: value.unitName,
          codeDescriptionUnit: value.codeDescriptionUnit
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.service-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }

  &.cost {
    width: 150px;
  }

  &.minimumAdvanceDuration {
    width: 80px;
  }
}

.input > textarea {
  min-height: 120px;
}

.service-product-cost-section {
  margin-top: 14px;
}

.service-product-cost-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
  flex-wrap: wrap;
}

.service-product-cost-title {
  margin-bottom: 0;
}

.service-product-cost-input {
  margin-bottom: 6px;
}

.service-product-promotion-meta {
  margin-bottom: 20px;
}

.inputChoice {
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
}

.thumbnail {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.icon-container {
  max-width: 180px;
}

.provider-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.provider-select {
  width: 100%;
}

.externalLink {
  padding-left: 30px;
}

.grid-botton-combine {
  display: grid;
  grid-template-columns: 190px 200px;
  grid-gap: 10px;
}

.revenue-dropdown {
  width: 300px;
}

.service-vat {
  font-size: 16px;
  color:  rgb(248, 103, 103);
}
</style>
